import type { FunctionReturnType } from "convex/server";

import { api } from "../../../../convex/_generated/api";

export const identityReconciliationAlertQuery = api.scheduler.reconciliation.readIdentityAlert;
export type IdentityReconciliationAlertResult = FunctionReturnType<
  typeof identityReconciliationAlertQuery
>;
